/**
 * @module app.shared
 */

import { RouteConfig } from 'aurelia-router';
import { ReadonlyIndexed } from 'app/shared/lib/types';
import { IAppRouteConfig } from 'app/shared/config/router-types';

export interface IDynamicView {
    /**
     * Title of Dynamic View (or **key** used to localize title)
     */
    readonly title: string,

    /**
     * URL of View/View-Model for Dynamic View
     */
    readonly url: string,

    /**
     * Key of Icon Resource for Dynamic View *(optional)*
     */
    readonly icon?: string
}

export type DynamicViews = ReadonlyIndexed<IDynamicView[]>;

export abstract class AppModule {

    public static readonly registrationKey = AppModule;

    public abstract readonly code: string;

    public getRoutes(): ReadonlyArray<IAppRouteConfig> {
        return [];
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return [];
    }

    public getDynamicViews(scope: string): DynamicViews {
        return {};
    }

    public toString(): string {
        return `[AppModule: ${this.code}]`;
    }

}

export interface IMemberFilter {
    view?: string,
    viewModel: string,
    filterName: string,
    label: string,
    operation?: string,
    moduleCode?: string,
    showInModules?: string[];
}

export class MemberFilters {

    private readonly filters: IMemberFilter[] = [];

    public getFilter(filterName: string): IMemberFilter | undefined {
        return this.filters.find(f => f.filterName === filterName);
    }

    public getFilters(): ReadonlyArray<IMemberFilter> {
        return [...this.filters];
    }

    public registerFilters(memberFilters: IMemberFilter[]): void {
        this.filters.push(...memberFilters);
    }

}
